<template>
  <div>
    <div class="tabs is-separatedUnderlined is-fullwidth is-marginless-bottom">
      <ul class="has-text-weight-medium">
        <li :class="{'is-active':tab === 'rdv'}"><a>1 - Détails</a></li>
        <li :class="{'is-active':tab === 'confirm'}"><a :class="{'disabled' : confirmedRdv === null}" >2 - Confirmation</a>
        </li>
      </ul>
    </div>
    <form @submit.prevent.stop="" v-if="tab === 'rdv'">
       <div class="has-bg-annonce columns is-vcentered" v-if="isExported && !googleLogged">
        <div class="column is-narrow is-padding-top-xsmall is-padding-bottom-xsmall">
          <span class="icon has-text-white"><i class="fas fa-engine-warning fa-lg"></i></span>
        </div>
        <div class="column is-paddingless-left is-padding-top-xsmall is-padding-bottom-xsmall">
          <div class="has-text-white is-italic is-size-6">
            <span>Ce rendez-vous est lié au compte Google de l'utilisateur : {{rdv.exported_by_name}}.</span>
            <span>Pour le modifier vous devez vous <a @click="makeGoogleLogin" class="is-underline has-text-white is-italic"> connecter à votre compte Google agenda</a>. Si le calendrier de l'utilisateur est partagé avec le votre vous pourrez enregistrer vos modifications.</span>
          </div>
        </div>
      </div>
      <div class="has-bg-danger columns is-vcentered" v-else-if="isExported && !canEdit">
        <div class="column is-padding-left is-padding-top-small is-padding-bottom-small">
          <div class="has-text-white is-size-6">
            <span>Validation impossible : Pas de connexion avec le compte Google de l'utilisateur : {{rdv.exported_by_name}}</span>
          </div>
        </div>
      </div>
      <div class="has-bg-googleAgenda columns is-vcentered" v-else-if="isExported && canEdit">
        <div class="column is-padding-left is-padding-top-small is-padding-bottom-small">
          <div class="has-text-white is-size-6">
            <span>Évènement synchronisé sur votre agenda Google.</span>
            <em v-if="rdv && rdv.google_last_sync">(dernière synchronisation {{rdv.google_last_sync | prettyDate}})</em>
          </div>
        </div>
        <a class="column is-narrow is-padding-top-small is-padding-bottom-small has-bg-white"
              @click="googleSync(rdv)">
          <span class="icon has-text-googleAgenda"><i class="fas fa-sync" :class="{'fa-spin': syncLoading}"></i></span>
        </a>
      </div>
      <div class="columns has-bg-grey2 is-vcentered">
        <div v-if="!isSeller" class="column is-6">
          <!-- <span class="label is-padding-bottom-xsmall"></span> -->
          <input id="selfRdv" type="checkbox" name="selfRdv" @click="changeSelfRdv(selfRdv)"
                 class="switch is-success is-rounded is-medium" v-model="selfRdv">
          <label for="selfRdv" class="label is-paddingless-top">
            <span
              class="is-size-5 is-transform-none has-text-grey has-text-weight-normal">Ce rendez-vous est pour moi</span>
          </label>
        </div>
        <div class="column is-6 is-paddingless-top is-paddingless-bottom is-zindex-2"
             v-if="!isSeller && !selfRdv && !seller">
          <button class="button is-grey is-outlined is-rounded is-fullwidth is-transform-none"
                  @click.prevent.stop="openSellerSelectionQuickView({type: 'seller'})">
            <span class="icon"><i class="fas fa-users-crown"></i></span>
            <span>Sélectionner un utilisateur</span>
          </button>
        </div>
      </div>
      <div class="columns is-multiline is-border-top" v-if="seller">
        <div class="column is-12 is-padding-top-small is-padding-bottom-small has-bg-light">
          <span class="label">Ce rendez-vous pour :</span>
        </div>
        <div class="column is-6">
          <div class="columns is-gapless">
            <div class="column is-9 is-vcentered columns">
              <avatar :item="seller"></avatar>
              <div class="is-margin-left-small">
                <div class="title is-4"><b>{{seller.last_name}} {{seller.first_name}}</b></div>
                <div class="subtitle">{{seller.profil_type|profilTypeLabel}}</div>
              </div>
            </div>
            <div class="column is-3 has-text-right actions">
              <a class="button is-circle" @click="seller = null; contact = null"><i class="fal fa-times"></i></a>
            </div>
          </div>
        </div>
      </div>
      <div class="columns is-multiline has-bg-light is-padding-bottom">
        <div class="column is-6 is-5-widescreen is-paddingless-bottom">
          <span class="label">Heure et date</span>
        </div>
        <div class="column is-3 is-5-widescreen is-paddingless-bottom">
          <div class="label">Type de RDV</div>
        </div>
        <div class="column is-3 is-2-widescreen is-paddingless-bottom">
          <span class="label">Durée estimée</span>
        </div>
        <div
          class="column is-6 is-5-widescreen is-paddingless-bottom is-padding-top-xsmall has-flatpickr-responsive has-flatpickr-time-push-top"
          v-if="!loading">
          <flat-pickr :config="configDate" v-model="date"
                      class="input is-radiusless is-hidden is-shadowless is-border"
                      name="date"
                      :class="{'is-danger': errors.has('date')}" v-validate="'required'" data-vv-as="Date du Rdv">
          </flat-pickr>
        </div>
        <div class="column is-3 is-5-widescreen is-padding-top-xsmall is-padding-left-small is-padding-right-small">
          <div class="columns is-gapless is-multiline">
            <div
              class="column is-12 is-6-widescreen is-padding-left-xsmall is-padding-right-xsmall is-padding-bottom-xsmall">
              <input id="rdvR0" v-model="rdv.rdv_type" value="R0" @click="rdv.rdv_type = 'R0'" name="typeRdv"
                     checked="checked" class="checkradiocase is-primary is-fullwidth" type="radio">
              <label class="" for="rdvR0">R0</label>
            </div>
            <div
              class="column is-12 is-6-widescreen is-padding-left-xsmall is-padding-right-xsmall is-padding-bottom-xsmall">
              <input id="rdvR1" v-model="rdv.rdv_type" value="R1" @click="rdv.rdv_type = 'R1'" name="typeRdv"
                     checked="checked" class="checkradiocase is-primary is-fullwidth" type="radio">
              <label class="" for="rdvR1">R1</label>
            </div>
            <div
              class="column is-12 is-6-widescreen is-padding-left-xsmall is-padding-right-xsmall is-padding-bottom-xsmall">
              <input id="rdvR2" v-model="rdv.rdv_type" value="R2" @click="rdv.rdv_type = 'R2'" name="typeRdv"
                     checked="checked" class="checkradiocase is-primary is-fullwidth" type="radio">
              <label class="" for="rdvR2">R2</label>
            </div>
            <div
              class="column is-12 is-6-widescreen is-padding-left-xsmall is-padding-right-xsmall is-padding-bottom-xsmall">
              <input id="rdvR3" v-model="rdv.rdv_type" value="R3" @click="rdv.rdv_type = 'R3'" name="typeRdv"
                     checked="checked" class="checkradiocase is-primary is-fullwidth" type="radio">
              <label class="" for="rdvR3">R3</label>
            </div>
            <!-- <div class="column is-12 is-padding-left-xsmall is-padding-right-xsmall is-padding-bottom-xsmall">
              <input id="rdvEvenement" v-model="rdv.rdv_type" value="evenement" @click="rdv.rdv_type = 'evenement'" name="typeRdv" checked="checked" class="checkradiocase is-primary is-fullwidth" type="radio">
              <label class="" for="rdvEvenement">Evènement</label>
            </div> -->
          </div>
        </div>
        <div class="column is-3 is-2-widescreen is-paddingless-bottom is-padding-top-xsmall">
          <div class="settingsSimpleActions settingsSimpleActions--v">
            <a @click="duration += 0.5" class="settingsSimpleActions-action">
              <span class="icon is-large"><i class="fal fa-plus-circle"></i></span>
            </a>
            <div class="settingsSimpleActions-feedback">
              <span>{{duration | durationLabel}}</span>
            </div>
            <a @click="duration -= 0.5" class="settingsSimpleActions-action">
              <span class="icon is-large"><i class="fal fa-minus-circle"></i></span>
            </a>
          </div>
        </div>
      </div>
      <div class="columns is-multiline is-border-top" v-if="!contact">
        <div class="column is-12 is-padding-top-small is-padding-bottom-small has-bg-light">
          <span class="label">Rendez-vous avec :</span>
        </div>
        <div v-if="totalContact !== null && totalContact === 0 && !contact"
             class="column is-12 is-paddingless-bottom">
          <div class="notification is-warning is-radius is-size-6 is-padding-top-small is-padding-bottom-small">
            <p>Ce vendeur ne possède pas de contact actuellement.</p>
          </div>
        </div>
        <div class="column is-narrow is-padding-top is-padding-right-xsmall" v-if="totalContact > 0">
          <button class="button is-white is-border is-rounded is-padding-right-large is-padding-left-large"
                  @click="openContactSelectionQuickView">
            <span class="icon is-medium is-padding-right-xsmall"><i class="is-size-4 fas fa-users-crown"></i></span>
            <span class="is-transform-none">Sélectionner un contact existant</span>
          </button>
        </div>
        <div class="column is-narrow is-padding-top is-padding-right-xsmall">
          <button class="button is-white is-border is-rounded is-padding-right-large is-padding-left-large"
                  @click="openNewContactQuickView">
            <span class="icon is-medium is-padding-right-xsmall"><i class="is-size-4 fas fa-user-crown"></i></span>
            <span class="is-transform-none">Créer un nouveau contact</span>
          </button>
        </div>
      </div>
      <div class="columns is-multiline is-border-top" v-else>
        <div class="column is-12 is-padding-top-small is-padding-bottom-small has-bg-light">
          <span class="label">Contact :</span>
        </div>
        <div class="column is-6">
          <div class="columns is-gapless">
            <div class="column is-9 is-vcentered columns">
              <avatar :item="contact" :usePicto="'contact'"></avatar>
              <div class="is-margin-left-small">
                <div class="title is-4">
                  <b>{{contact.last_name}} {{contact.first_name}}</b>
                  <div class="is-size-5" v-if="contact.address && contact.address.zip_code">
                    {{contact.address.line1 || ''}} {{contact.address.zip_code || ''}} {{contact.address.city || ''}}
                  </div>
                </div>
              </div>
            </div>
            <div class="column is-3 has-text-right actions">
              <a class="button is-circle" @click="contact = null">
                <i class="fal fa-times"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
      <div class="columns is-multiline is-border-top">
        <div class="column is-12 is-padding-top-small is-padding-bottom-small has-bg-light">
          <span class="label">Adresse du rendez-vous :</span>
        </div>
        <div class="column is-12 is-padding-top is-paddingless-bottom" v-if="contact">
          <input id="adressContact" name="adressContact" class="switch is-success is-rounded is-medium" type="checkbox"
                 v-model="selectContactAddress">
          <label for="adressContact" class=""><span class="is-size-5">Adresse du contact</span></label>
        </div>
        <div class="column is-12 columns is-vcentered is-paddingless">
          <div class="column is-paddingless-top is-paddingless-left">
            <gmap-input :source="address" @submit="updateAddress" :label="'Adresse du rendez-vous'"></gmap-input>
          </div>
        </div>
      </div>
      <div class="columns is-multiline is-border-top" v-if="guests && guests.length > 0">
        <div class="column is-12 is-padding-top-small is-padding-bottom-small has-bg-light">
          <span class="label" v-if="guests.length > 1">Utilisateurs invité(s) :</span>
          <span class="label" v-else>Utilisateur invité :</span>
        </div>
        <div class="column is-6 is-6-widescreen" v-if="guests && guests.length" v-for="(guest, i) in guests"
             :key="guest.pk">
          <div class="columns is-gapless">
            <div class="column is-9 columns is-vcentered">
              <avatar :item="guest" :usePicto="'utilisateur'"></avatar>
              <div class="is-margin-left-small">
                <div class="title is-4"><b>{{guest.last_name}} {{guest.first_name}}</b></div>
                <div class="subtitle">{{guest.profil_type|profilTypeLabel}}</div>
              </div>
            </div>
            <div class="column is-3 has-text-right actions">
              <a class="button is-circle" @click="deleteGuest(i)"><i class="fal fa-times"></i></a>
            </div>
          </div>
        </div>
      </div>
      <div class="columns is-multiline">
        <div class="column is-12 columns is-paddingless-top is-paddingless-bottom is-border-top has-bg-light">
          <div class="field is-grouped">
            <div class="control is-border-right is-marginless">
              <button class="button is-light has-text-grey is-radiusless is-small"
                      @click.prevent.stop="openSellerSelectionQuickView({type: 'guest', mode: 'append', excludes: excludesGuests})">
                <span class="icon is-large"><i class="fas fa-user-plus"></i></span>
                <span class="">Inviter un utilisateur</span>
              </button>
            </div>
            <div class="control is-border-right is-marginless">
              <button class="button is-light has-text-grey is-radiusless is-small" v-if="!showNote"
                      @click="showNote = true">
                <span class="icon is-large"><i class="fas fa-comment-alt"></i></span>
                <span class="">Ajouter une note</span>
              </button>
              <button class="button is-light has-text-grey is-radiusless is-small" v-else
                      @click="showNote = false; rdv.note = null">
                <span class="icon is-large"><i class="fas fa-comment-alt"></i></span>
                <span class="">Supprimer la note</span>
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="columns is-multiline is-border-top has-bg-light" v-if="showNote">
        <div class="column is-12 is-padding-top-small is-padding-bottom-small">
          <label for="rdvNote" class="label">Note :</label>
        </div>
        <div class="column is-12 is-paddingless-top">
          <div class="field" @mouseover="displayToolbar = true" @mouseleave="displayToolbar = false">
            <div class="control">
              <wysiwyg-editor :model="rdv.note" placeholder="" :light='true'
                              @change="val => updateNote(val)"
                              :class="{'editr--hide-toolbar':!displayToolbar}"
                              class="editr--bottom-toolbar editr--height-small content has-bg-white"/>
            </div>
          </div>
          <p v-if="noteError" class="help is-danger">Maximum 255 charactères dans le champs note</p>
        </div>
      </div>
      <div class="column is-12 is-paddingless is-border-top columns">
        <div class="column">
          <button class="button is-white is-fullwidth" @click="cancel">Annuler</button>
        </div>
        <div v-if="isExported && !googleLogged" class="column">
          <a class="button is-fullwidth is-googleAgenda" @click="makeGoogleLogin">
            <span>Connexion à votre compte google</span>
          </a>
        </div>
        <div v-else-if="isExported && !canEdit" class="column">
          <a class="button is-success is-fullwidth"
            disabled="disabled">
            <span v-if="!loading">Valider mon rendez-vous</span>
          </a>
        </div>
        <div v-else class="column">
          <a class="button is-success is-fullwidth"
             @click="submit" :disabled="loading" :class="{'is-loading':loading}">
            <span v-if="!loading">Valider mon rendez-vous</span>
          </a>
        </div>
      </div>
    </form>
    <div class="columns is-multiline" v-if="tab === 'confirm' && confirmedRdv">
      <div class="column is-12 is-paddingless-bottom">
        <div class="notification is-rdv is-radius-large is-padding-small has-text-white">
          <div class="columns is-gapless">
            <div class="column is-narrow is-margin-right-small">
              <span class="icon is-large"><i class="fas fa-check fa-lg"></i></span>
            </div>
            <div class="column">
              <p>Le rendez-vous avec <b>{{confirmedRdv.contact_name}}</b>
                a été correctement {{isNew ? 'créé' : 'modifié'}}.
                <br>
                <b>Date : le {{confirmedRdv.date | prettyDate}}</b>
                <br>
                <b>Heure de début : {{confirmedRdv.date | prettyTime}} - Heure de fin : {{confirmedRdv.end_date
                  | prettyTime}}</b>
                <br>
                <b>Invité(s) :</b>
                <span v-if="confirmedRdv.guests_name && confirmedRdv.guests_name.length">
                  {{confirmedRdv.guests_name.join(', ')}}
                </span>
                <span v-else><b>Aucun</b></span>
              </p>
              <p class="is-margin-top-small">
                <router-link :to="{name: 'CalendarEdit', params: {id: confirmedRdv.pk}}" class="has-text-white"
                             v-if="isNew">
                  Modifier ce rendez-vous
                </router-link>
                <a @click="tab = 'rdv'" class="has-text-white" v-else>Modifier ce rendez-vous</a>
              </p>
            </div>
          </div>
        </div>
      </div>
      <div v-if="isRdvSeller && !isExported" class="column is-12 is-paddingless-bottom">
        <span class="label">Exporter vers vos agendas</span>
        <div class="field is-grouped is-margin-top-xsmall">
          <div class="control">
            <button class="button is-googleAgenda is-rounded is-transform-none" @click="checkGoogle(confirmedRdv)">
              <span class="icon"><i class="fab fa-google"></i></span>
              <span>Exporter vers mon calendrier Googe</span>
            </button>
          </div>
          <div class="control">
            <a class="button is-light is-rounded is-transform-none" :href="icsUrl" target="_blank">
              <span class="icon"><i class="fas fa-calendar-alt"></i></span>
              <span>Exporter vers un autre calendrier (.ics)</span>
            </a>
          </div>
        </div>
      </div>
      <div class="column is-12 is-paddingless is-border-top columns is-margin-top">
        <div class="column">
          <router-link :to="{name: 'CalendarEdit', params: {id: confirmedRdv.pk}}"
                       class="button is-white is-fullwidth" v-if="isNew">Modifier
          </router-link>
          <a v-else @click="tab = 'rdv'" class="button is-white is-fullwidth">Modifier</a>
        </div>
        <div class="column">
          <a @click="openRdv(confirmedRdv)" class="button is-success is-fullwidth">Accéder au rendez-vous</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapState, mapGetters } from 'vuex'
  import { isNil, cloneDeep } from 'lodash'
  import moment from 'moment'
  import { DefaultValues, GoogleMx } from '@/mixins'

  const emptyRdv = Object.freeze({
    rdv_type: 'R0',
    address: null,
    guests: [],
    date: null,
    seller: null,
    note: null,
    end_date: null,
    contact: null
  })
  const durations = [
    {value: 0.5, label: '30 min'},
    {value: 1, label: '1h'},
    {value: 1.5, label: '1h30'},
    {value: 2, label: '2h'},
    {value: 2.5, label: '2h30 min'},
    {value: 3, label: '3h'},
    {value: 3.5, label: '3h30 min'},
    {value: 4, label: '4h'}
  ]

  export default {
    name: 'CalendarForm',
    mixins: [DefaultValues, GoogleMx],
    props: {
      confirmedRdv: {
        type: Object
      },
      initialDate: {
        type: String,
        required: false
      },
      initialContact: {
        type: String,
        required: false
      },
      source: {
        type: Object,
        required: false
      },
      loading: {
        type: Boolean,
        default: false
      },
      isExported: {
        type: Boolean,
        default: false
      },
      syncLoading: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        rdv: {},
        date: null,
        endDate: null,
        showNote: false,
        seller: null,
        selfRdv: true,
        duration: 2,
        contact: null,
        guest: null,
        guests: [],
        guests_name: [],
        displayToolbar: false,
        configDate: {
          altInput: true,
          altFormat: 'j M Y H:i',
          dateFormat: 'Z',
          time_24hr: true,
          enableTime: true,
          inline: true
        },
        durations,
        sellerContacts: null,
        guestSelect: false,
        totalContact: null,
        isLoadingContact: false,
        tab: 'rdv',
        noteError: false,
        selectContactAddress: false,
        initAddress: null,
        loadingRdv: false,
        address: null
      }
    },
    computed: {
      ...mapState(['gApiReady', 'googleLogged', 'quickview', 'googleCalendars']),
      ...mapGetters(['isSeller', 'currentUserPk', 'googleCalendarsId', 'isAdmin', 'isSectorManager', 'isManager', 'isOperator']),
      isRdvSeller () {
        return this.rdv.seller === this.currentUserPk || this.confirmedRdv.seller === this.currentUserPk
      },
      excludedContactPk () {
        let tab = []
        if (this.contact) {
          tab.push(this.contact.pk)
        }
        return tab
      },
      guestsPk () {
        return this.guests.map(x => x.pk)
      },
      isNew () {
        return isNil(this.rdv.pk) || this.rdv.pk === ''
      },
      excludesGuests () {
        if (this.sellerPk) {
          return this.guestsPk.concat(this.sellerPk)
        } else return this.guestsPk
      },
      sellerPk () {
        if (this.isSeller || this.selfRdv) {
          return this.currentUserPk
        } else if (this.seller) {
          return this.seller.pk
        } else {
          return null
        }
      },
      icsUrl () {
        const apiUrl = this.$configs.APIROOT
        const rdvPk = this.confirmedRdv.pk
        return `${apiUrl}/ical/${rdvPk}`
      },
      isSameCalendar () {
        let myCalendar = []
        this.googleCalendars.forEach(x => {
          myCalendar.push(x.id)
        })
        if (myCalendar.includes(this.rdv.google_calendar_id)) return true
        return false
      },
      isInMyCalendar () {
        return this.googleCalendarsId.includes(this.rdv.google_calendar_id)
      },
      isMyRdv () {
        return [this.rdv.author.pk || this.rdv.author, this.rdv.seller.pk || this.rdv.seller].includes(this.currentUserPk)
      },
      canEdit () {
        if (this.isExported && this.googleLogged) {
          return (this.isAdmin || this.isSectorManager || this.isManager || this.isOperator || this.isMyRdv) && this.isInMyCalendar
        } else {
          return this.isAdmin || this.isSectorManager || this.isManager || this.isOperator || this.isMyRdv
        }
      }
    },
    filters: {
      durationLabel (val) {
        let duration = durations.find(x => x.value === val)
        if (duration) {
          return duration.label
        }
      }
    },
    watch: {
      selfRdv (v) {
        this.seller = null
        this.contact = null
        if (v) this.deleteMeFromGuests()
      },
      seller (v) {
        if (v) {
          this.getContactsCount()
        }
      },
      duration (v) {
        let min = durations[0].value
        let max = durations[durations.length - 1].value
        if (v < min) {
          this.duration = min
        } else if (v > max) {
          this.duration = max
        }
      },
      selectContactAddress (v) {
        if (v) {
          this.$set(this.rdv, 'address', this.contact.address)
          this.$set(this, 'address', this.contact.address)
        } else {
          this.$set(this, 'address', cloneDeep(this.initAddress))
          this.$set(this.rdv, 'address', cloneDeep(this.initAddress))
        }
      },
      quickview ({mode, params, results}) {
        if (results) {
          if (mode === 'SELLER_SELECTION' && params.type === 'seller') {
            this.seller = results.entities[0]
            this.getContactsCount()
          } else if (mode === 'SELLER_SELECTION' && params.type === 'guest') {
            results.entities.forEach(x => {
              this.guests.push(x)
            })
          } else if (mode === 'CONTACT_SELECTION') {
            this.contact = results.entities[0]
          } else if (mode === 'NEW_CONTACT') {
            this.submitContact(results.contact)
          }
        }
      }
    },
    methods: {
      cancel () {
        this.$emit('cancel')
      },
      updateNote (val) {
        this.$set(this.rdv, 'note', val)
        val.length > 255 ? this.noteError = true : this.noteError = false
      },
      changeSelfRdv (v) {
        if (v && !this.loadingRdv) {
          this.openSellerSelectionQuickView({type: 'seller'})
        }
      },
      deleteGuest (i) {
        this.guests.splice(i, 1)
        this.guests_name.splice(i, 1)
      },
      getContact (contactPk) {
        this.$api.contactService.getOne(contactPk).then(r => {
          this.contact = r.data
        })
      },
      deleteMeFromGuests () {
        let idx = this.guests.findIndex(x => x.pk === this.currentUserPk)
        if (idx >= 0) {
          this.deleteGuest(idx)
        }
      },
      getContactsCount () {
        let query = {
          per_page: 1
        }
        if (this.seller) {
          query.seller = this.seller.pk
        }
        this.$api.contactService.get(query).then(r => {
          this.totalContact = r.data.total
        })
      },
      openContactSelectionQuickView () {
        if (this.seller || this.selfRdv) {
          let params = {
            excludes: this.excludedContactPk,
            mode: 'store'
          }
          if (this.isSeller || this.selfRdv) {
            params.seller = this.currentUserPk
          } else {
            params.seller = this.seller.pk
          }
          this.$store.commit('setQuickview', {mode: 'CONTACT_SELECTION', params: params})
        }
      },
      openNewContactQuickView () {
        if (this.seller || this.selfRdv) {
          this.$store.commit('setQuickview', {
            mode: 'NEW_CONTACT',
            params: {
              showSellerSelect: false
            }
          })
        }
      },
      openSellerSelectionQuickView (params) {
        if (isNil(params)) {
          params = {}
        }
        if (!params.excludes) params.excludes = [this.currentUserPk]
        let finalParams = Object.assign({}, params)
        finalParams.facets = {
          'USER': ['is_external:False', 'is_operator:False', 'is_editor:False']
        }
        this.$store.commit('setQuickview', {mode: 'SELLER_SELECTION', params: finalParams})
      },
      openRdv (data) {
        let day = moment(data.date).format('DD')
        let month = moment(data.date).format('MM')
        let year = moment(data.date).format('YYYY')
        this.$router.push({name: 'CalendarDayView', query: {day, month, year}})
      },
      submit () {
        let hour = document.querySelector('.flatpickr-hour').value
        let minute = document.querySelector('.flatpickr-minute').value
        let newDate = moment(this.date).set({'hour': hour, 'minute': minute})
        this.date = newDate._d

        if (isNil(this.contact)) {
          this.$notify({
            type: 'is-danger',
            text: 'Vous devez indiquer le contact associé au rendez-vous.'
          })
          return
        }
        if (!this.selfRdv && isNil(this.seller)) {
          this.$notify({
            type: 'is-danger',
            text: 'Vous devez indiquer le vendeur associé au rendez-vous.'
          })
          return
        }
        this.$validator.validateAll().then((valid) => {
          if (valid) {
            let rdv = Object.assign({}, this.rdv)
            if (!this.selfRdv) {
              rdv.seller = this.seller.pk
            } else rdv.seller = this.currentUserPk
            rdv.contact = this.contact.pk
            if (this.guests.length) {
              rdv.guests = this.guests.map(x => x.pk)
            }
            rdv.date = moment.utc(this.date).format('DD/MM/YYYY HH:mm')
            let endDate = moment(this.date).add(this.duration, 'h')
            rdv.end_date = moment.utc(endDate).format('DD/MM/YYYY HH:mm')

            this.$set(this, 'tab', 'confirm')
            this.$emit('submit', rdv)
          } else {
            this.$notify({
              type: 'is-danger',
              text: 'Le formulaire est invalide.'
            })
          }
        })
      },
      submitContact (contact) {
        this.isLoadingContact = true
        contact.seller = this.sellerPk
        this.$api.contactService.post(contact).then(res => {
          this.contact = res.data
          this.isLoadingContact = false
          this.$notify({
            type: 'is-success',
            text: 'Le contact a été créé.'
          })
        }).catch(() => {
          this.isLoadingContact = false
          this.$notify({
            type: 'is-danger',
            text: 'Erreur lors de la création du contact.'
          })
        })
      },
      updateAddress ({address, location}) {
        this.$set(this.rdv, 'address', address)
        this.$set(this, 'address', address)
      }
    },
    created () {
      this.loadingRdv = true
      this.getContactsCount()
      if (isNil(this.source) === false) {
        this.rdv = Object.assign(this.rdv, this.source)
        if (this.source.note) {
          this.showNote = true
        }
        this.initAddress = cloneDeep(this.source.address)
        this.address = this.source.address
        if ('date' in this.source && this.source.date) {
          this.date = moment(this.source.date).toDate()
        } else {
          this.date = moment().add(1, 'day').hours(8).startOf('hour').toDate()
        }
        this.endDate = moment(this.source.end_date).toDate()
        this.duration = moment(this.source.end_date).diff(moment(this.source.date), 'hours', true).toFixed(1)
        if (!durations.find(x => Number(x.value) === Number(this.duration))) {
          this.duration = Number(Math.round(this.duration))
        } else {
          this.duration = Number(this.duration)
        }
        if (this.source.guests && this.source.guests.length) {
          this.source.guests.forEach((guest, i) => {
            let guestPk = this.source.guests[i]
            let guestName = this.source.guests_name[i].split(' ')
            this.guests.push({
              pk: guestPk,
              first_name: guestName.shift(),
              last_name: [...guestName].join(' ')
            })
          })
        }
        if (this.source.seller !== this.currentUserPk) {
          this.selfRdv = false
          this.$api.userService.getOne(this.source.seller).then(r => {
            this.$set(this, 'seller', Object.assign({}, r.data))
          })
        }
        this.$api.contactService.getOne(this.source.contact).then(r => {
          this.$set(this, 'contact', Object.assign({}, r.data))
        })
      } else {
        Object.assign(this.rdv, emptyRdv)
        if (this.initialDate) {
          this.date = moment(this.initialDate, 'DD/MM/YYYY').hours(8).startOf('hour').toDate()
        } else {
          this.date = moment().add(1, 'day').hours(8).startOf('hour').toDate()
        }
        if (this.initialContact) {
          this.getContact(this.initialContact)
        }
        if (this.$route.query && this.$route.query.seller) {
          this.selfRdv = false
          this.$api.userService.getOne(this.$route.query.seller).then(r => {
            this.$set(this, 'seller', Object.assign({}, r.data))
          })
        }
        if (this.$route.query && this.$route.query.contact) {
          this.$api.contactService.getOne(this.$route.query.contact).then(r => {
            this.$set(this, 'contact', Object.assign({}, r.data))
          })
        }
        if (this.$route.query && this.$route.query.date) {
          this.date = moment(this.$route.query.date.split('/').reverse().join('/')).toDate()
        }
        if (this.$route.query && this.$route.query.day && this.$route.query.month && this.$route.query.year) {
          let query = this.$route.query
          this.date = moment().date(query.day).month(query.month).year(query.year).hours(8).startOf('hour').toDate()
        }
      }
      this.loadingRdv = false
      if (this.confirmedRdv) {
        this.tab = 'confirm'
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/calendar/CalendarForm.vue